import { BASE_URL } from '@constants/environment';
import React from 'react';

class Reload extends React.Component {
  componentDidMount() {
    const { shouldRedirectToSignIn } = this.props;
    if (shouldRedirectToSignIn) {
      window.location.href = `${BASE_URL}signin?from=${encodeURIComponent(window.location.href)}`;
    } else {
      window.location.reload();
    }
  }

  render() {
    return null;
  }
}

export default Reload;
